<script setup lang="ts">
import type { ErrorCode } from '@/types'

withDefaults(
  defineProps<{
    code: ErrorCode
    message: string
    compact?: boolean
  }>(),
  { compact: false },
)

const emit = defineEmits<{ retry: [] }>()
</script>

<template>
  <div class="err" :class="{ 'err--compact': compact }" role="alert">
    <span class="err__glyph" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5v5.5" stroke-linecap="round" />
        <path d="M12 16.4v.1" stroke-linecap="round" />
      </svg>
    </span>

    <div class="err__body">
      <p class="err__message">{{ message }}</p>
      <p class="err__code mono">{{ code }}</p>
    </div>

    <button type="button" class="btn btn--ghost err__action" @click="emit('retry')">
      Tentar de novo
    </button>
  </div>
</template>

<style scoped>
.err {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem 0.875rem;
  align-items: start;
  padding: 1.125rem;
  border: 1px solid var(--danger-line);
  border-radius: var(--radius-lg);
  background: var(--danger-soft);
  animation: rise 320ms var(--ease-out) both;
}

.err--compact {
  padding: 0.875rem 1rem;
  border-radius: var(--radius);
}

.err__glyph {
  display: grid;
  place-items: center;
  width: 1.375rem;
  height: 1.375rem;
  margin-top: 0.125rem;
  color: var(--danger);
}

.err__glyph svg {
  width: 100%;
  height: 100%;
}

.err__message {
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--text);
}

.err__code {
  margin-top: 0.25rem;
  font-size: var(--step--2);
  letter-spacing: 0.1em;
  color: var(--danger);
  opacity: 0.75;
}

.err__action {
  grid-column: 2;
  justify-self: start;
  min-height: 2.625rem;
  padding-inline: 1.125rem;
  font-size: var(--step--1);
}
</style>
